/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GraphEdgeDto
 */
export interface GraphEdgeDto {
    /**
     * 
     * @type {string}
     * @memberof GraphEdgeDto
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof GraphEdgeDto
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof GraphEdgeDto
     */
    target: string;
    /**
     * 
     * @type {string}
     * @memberof GraphEdgeDto
     */
    type: string | null;
}

/**
 * Check if a given object implements the GraphEdgeDto interface.
 */
export function instanceOfGraphEdgeDto(value: object): value is GraphEdgeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GraphEdgeDtoFromJSON(json: any): GraphEdgeDto {
    return GraphEdgeDtoFromJSONTyped(json, false);
}

export function GraphEdgeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GraphEdgeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'source': json['source'],
        'target': json['target'],
        'type': json['type'],
    };
}

export function GraphEdgeDtoToJSON(json: any): GraphEdgeDto {
    return GraphEdgeDtoToJSONTyped(json, false);
}

export function GraphEdgeDtoToJSONTyped(value?: GraphEdgeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'source': value['source'],
        'target': value['target'],
        'type': value['type'],
    };
}

